import { getChartLabel } from "./chartLabel";
import React, { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";
import { Form } from "react-bootstrap";
import CustomLegend from "./CustomLegend";
import CustomTooltip from "./CustomTooltip";

const Evths2 = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);

  // Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: "place", // default sort by place
    direction: "asc",
  });

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }

  const regData = data.map((item) => ({
    place: item.Place,
    HMIS_registration: Number(item.HMIS_registration),
  }));

  // Sorting logic
  const sortedData = [...regData].sort((a, b) => {
    if (a[sortConfig.key] < b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? -1 : 1;
    }
    if (a[sortConfig.key] > b[sortConfig.key]) {
      return sortConfig.direction === "asc" ? 1 : -1;
    }
    return 0;
  });

  // Handle sorting click
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === "asc" ? "desc" : "asc",
        };
      } else {
        return { key, direction: "asc" };
      }
    });
  };

  // Icon display function
  const getSortIcon = (key) => {
    if (sortConfig.key !== key) return "⬍"; // default icon
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  const chunkArray = (array, chunkCount) => {
    const result = [];
    const chunkSize = Math.ceil(array.length / chunkCount);

    for (let i = 0; i < array.length; i += chunkSize) {
      result.push(array.slice(i, i + chunkSize));
    }

    return result;
  };

  const getChartCount = (length) => {
   if (length < 9) return 1;
    if (length >= 9 && length <= 18) return 2;
    if (length <= 45) return 3;
    return Math.ceil(length / 20);
  };

  const chartCount = getChartCount(regData.length);
  const chunkedData = chunkArray(regData, chartCount);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      {/* Toggle Switch */}
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <div class="cardTitle">
              <h5>HMIS Registration {getChartLabel(filters, selectedState)}</h5>
              
            </div>

            <div class="cardDropDown gap-3">
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>

      {showTable ? (
        // Table View
        <div className="card hptCard mt-4 border-0">
          <div className="table-responsive">
            <table className="table table-bordered ">
              <thead className="thead-light">
                <tr>
                  <th className="fw-bold">Place</th>
                  <th
                    className="fw-bold text-center"
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => handleSort("HMIS_registration")}
                  >
                    HMIS Registration {getSortIcon("HMIS_registration")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, idx) => (
                  <tr key={idx}>
                    <td style={{ fontWeight: "bold" }}>{item.place}</td>
                    <td>{item.HMIS_registration}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        // Chart View
        <>
          {chunkedData.map((chunk, index) => (
            <div key={index} className="card hptCard mt-4 border-0">
              <ResponsiveContainer width="100%" height={600}>
                <BarChart
                  width={500}
                  height={600}
                  data={chunk}
                  margin={{
                    top: 50,
                    right: 30,
                    left: 20,
                    bottom: 130,
                  }}
                >
                  <XAxis
                    dataKey="place"
                    angle={-90}
                    textAnchor="end"
                    interval={0}
                  />
                  <YAxis />
                  <Tooltip content={<CustomTooltip />} />
                  <Legend
                    verticalAlign="top"
                    content={<CustomLegend order={["HMIS_registration"]} />}
                  />
                  <Bar
                    dataKey="HMIS_registration"
                    fill="#00a084"
                    name="HMIS Registration"
                  >
                    <LabelList
                      dataKey="HMIS_registration"
                      position="top"
                      content={({ x, y, width, value }) => {
                        if (value == null) return null;
                        return (
                          <text
                            x={x + width / 2} // center horizontally
                            y={y - 5} // position slightly above bar
                            fontSize={12}
                            fontWeight="bold"
                            textAnchor="start" // 👈 could also try "middle" for alignment
                            transform={`rotate(-90, ${x + width / 2}, ${y - 5})`}
                          >
                            {value}
                          </text>
                        );
                      }}
                    />
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ))}
        </>
      )}
    </div>
  );
};

export default Evths2;
